import { Controller } from "@hotwired/stimulus"

// Builder-side exception review (Larry 2026-08-06). Approving the last
// outstanding exception releases the contract for signature, so the page says
// so and drops the reviewer back on the contract.
export default class extends Controller {
  static targets = ["card", "badge", "note", "error", "empty"]
  static values = { url: String, contractUrl: String }

  approve(event) {
    this._review(event.currentTarget.closest("[data-doc-id]"), "approve")
  }

  decline(event) {
    this._review(event.currentTarget.closest("[data-doc-id]"), "decline")
  }

  async approveAll() {
    for (const card of Array.from(this.cardTargets)) {
      if (!card.classList.contains("hidden")) await this._review(card, "approve")
    }
  }

  async _review(card, decision) {
    const note = card.querySelector("[data-docs-review-target='note']")
    const error = card.querySelector("[data-docs-review-target='error']")
    if (error) error.classList.add("hidden")
    this._setBusy(card, true)

    try {
      const response = await fetch(this.urlValue.replace("DOC_ID", card.dataset.docId), {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || ""
        },
        body: JSON.stringify({ decision, note: note ? note.value.trim() : "" })
      })
      const data = await response.json().catch(() => ({}))
      if (!response.ok || !data.ok) throw new Error(data.error || "That couldn't be saved.")

      card.classList.add("hidden")
      if (data.released) {
        this._showReleased()
      } else if (!this.cardTargets.some((c) => !c.classList.contains("hidden"))) {
        this._showEmpty()
      }
    } catch (requestError) {
      if (error) {
        error.textContent = requestError.message
        error.classList.remove("hidden")
      }
    } finally {
      this._setBusy(card, false)
    }
  }

  _showReleased() {
    if (!this.hasEmptyTarget) return
    this.emptyTarget.classList.remove("hidden")
    this.emptyTarget.querySelector("p").textContent =
      "Everything is approved — the contract has gone out for signature."
    setTimeout(() => { window.location.href = this.contractUrlValue }, 1600)
  }

  _showEmpty() {
    if (this.hasEmptyTarget) this.emptyTarget.classList.remove("hidden")
  }

  _setBusy(card, busy) {
    card.querySelectorAll("button, input").forEach((el) => { el.disabled = busy })
    card.classList.toggle("opacity-60", busy)
  }
}
